// extracted by mini-css-extract-plugin
export default {"wrapper":"SlateEditor_wrapper__gviZN","fit_wrapper":"SlateEditor_fit_wrapper__IR-LP"};